import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { PregledAvansaComponent } from './pregled-avansa.component';

import { TabsModule } from 'beyond-util';

@NgModule({
  declarations: [PregledAvansaComponent],
  entryComponents: [PregledAvansaComponent],
  exports: [PregledAvansaComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
  ],
})
export class PregledAvansaModule {}



// WEBPACK FOOTER //
// ./src/app/pages/pregled-avansa/pregled-avansa.module.ts